export const CONSTANTS = {
  SISTEMA_INTERESSE_CCPF : '01',
  DAS: '9',
  DJE: '7'
} as const;
